/**
 * Hook for fetching section-location associations with planned dates.
 */

import { gql, useQuery } from "@apollo/client";

export interface SectionLocationItem {
  id: string;
  sectionId: string;
  locationId: string;
  plannedStart: string | null;
  plannedEnd: string | null;
}

interface SectionLocationConnection {
  items: SectionLocationItem[];
  totalCount: number;
  hasNextPage: boolean;
}

interface SectionLocationsQueryResult {
  sectionLocations: SectionLocationConnection;
}

const GET_SECTION_LOCATIONS = gql`
  query GetSectionLocations($limit: Int, $offset: Int) {
    sectionLocations(limit: $limit, offset: $offset) {
      items {
        id
        sectionId
        locationId
        plannedStart
        plannedEnd
      }
      totalCount
      hasNextPage
    }
  }
`;

export function useSectionLocations() {
  const { data, loading, error } = useQuery<SectionLocationsQueryResult>(
    GET_SECTION_LOCATIONS,
    {
      variables: { limit: 1000, offset: 0 },
      fetchPolicy: "cache-and-network",
    },
  );

  return {
    sectionLocations: (data?.sectionLocations.items || []) as SectionLocationItem[],
    totalCount: data?.sectionLocations.totalCount || 0,
    loading,
    error,
  };
}
